import { PersonalAccountItem, PersonalAccountItems, ReplenishmentBody } from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/personal-account';

export class PersonalAccountApi {
    public static async replenish(ehrId: string, params: ReplenishmentBody): Promise<void> {
        await axios.post(`${BASE_URL}/${ehrId}/replenish`, params);
    }

    public static async getItems(ehrId: string): Promise<PersonalAccountItem[]> {
        const res = await axios.get<PersonalAccountItems>(`${BASE_URL}/${ehrId}/item`);
        return res.data.items;
    }
}
